import {debounce} from "../../utils";

class VerticalGamesHero {
    constructor(canvas) {
        this.params = {
            breakpoints: {
                768: {
                    numLines: 10,
                    baseLineLength: 20,
                    lineWidth: 4,
                    lineHeight: 0.5,
                    spacer: 2,
                    widthRatio: 1,
                    heightRatio: 1,
                    easing: 0.05
                },
                1024: {
                    numLines: 12,
                    baseLineLength: 25,
                    lineWidth: 5,
                    lineHeight: 0.75,
                    spacer: 2,
                    widthRatio: 1,
                    heightRatio: 1,
                    easing: 0.05
                },
                1200: {
                    numLines: 16,
                    baseLineLength: 30,
                    lineWidth: 6,
                    lineHeight: 1,
                    spacer: 2,
                    widthRatio: 1,
                    heightRatio: 1,
                    easing: 0.05
                }
            },
        }
        this.canvas = canvas;

        this.hero = document.getElementById('games-hero')
        this.ctx = this.canvas.getContext("2d");
        this.updateParamsFromBreakpoints();

        this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerHeight;

        this.gridWidth = this.canvas.width / this.numLines;
        this.gridHeight = this.canvas.height / this.numLines;

        this.mouseX = this.canvas.width / 2;
        this.mouseY = this.canvas.height / 2;
        this.zCoordinate = 300;

        this.targetX = this.mouseX;
        this.targetY = this.mouseY;

        this.hero.addEventListener("mousemove", (event) => this.onMouseMove(event));
        window.addEventListener("resize", debounce(this.handleResize.bind(this), 100));

        this.lastBreakpoint = this.getCurrentBreakpoint();
        this.animate();
    }

    handleResize() {
        this.lastBreakpoint = this.getCurrentBreakpoint();
        this.updateParamsFromBreakpoints();

        this.canvas.width = window.innerWidth * this.params.breakpoints[this.lastBreakpoint].widthRatio;
        this.canvas.height = window.innerHeight * this.params.breakpoints[this.lastBreakpoint].heightRatio;

        this.gridWidth = this.canvas.width / this.numLines;
        this.gridHeight = this.canvas.height / this.numLines;
    }

    getCurrentBreakpoint() {
        return Object.keys(this.params.breakpoints)
                .find(bp => window.innerWidth < bp)
            || Object.keys(this.params.breakpoints).slice(-1)[0];
    }

    updateParamsFromBreakpoints() {
        const bp = this.getCurrentBreakpoint();
        const params = this.params.breakpoints[bp];

        for (let key in params) {
            this[key] = params[key];
        }

        this.lineWidth *= 6;
        this.lineHeight *= 4;
    }

    drawEllipseGroup(x1, y1, x2, y2, width, height) {
        const dx = x2 - x1;
        const dy = y2 - y1;

        const steps = Math.ceil(width / (height + this.spacer));

        for (let i = 0; i < steps; i++) {
            const t = i / (steps - 1);
            const x = x1 + dx * t;
            const y = y1 + dy * t;
            const offsetX = height * t;
            const offsetY = height * t;

            const zFactor = (1 - t) * this.zCoordinate / (this.zCoordinate * 2);

            this.ctx.beginPath();
            this.ctx.ellipse(x + offsetX, y - offsetY, height * (1 + zFactor), height / 2 * (1 + zFactor), 0, 0, 2 * Math.PI);
            this.ctx.fill();
        }
    }

    drawEllipseGroup2(x1, y1, x2, y2, width, height) {
        const dx = x2 - x1;
        const dy = y2 - y1;

        const steps = Math.ceil(width / (height + this.spacer));

        const x = x1;
        const y = y1;

        const zFactor = 0.5;
        const deltaX = height * (1 + zFactor);
        const deltaY = height / 2 * (1 + zFactor);

        this.ctx.beginPath();
        this.ctx.ellipse(x, y, deltaX, deltaY, 0, 0, 2 * Math.PI);
        this.ctx.fill();

        const xBack = x1 + dx;
        const yBack = y1 + dy;
        const deltaXBack = height;
        const deltaYBack = height / 2;

        this.ctx.beginPath();
        this.ctx.ellipse(xBack + 1, yBack - 1, deltaXBack, deltaYBack, 0, 0, 2 * Math.PI);
        this.ctx.fill();

        this.ctx.beginPath();
        this.ctx.moveTo(x - deltaX, y);
        this.ctx.lineTo(xBack - deltaXBack, yBack);
        this.ctx.lineTo(xBack + deltaXBack, yBack);
        this.ctx.lineTo(x + deltaX, y);
        this.ctx.closePath();
        this.ctx.fill();
        this.ctx.stroke();

        // this.ctx.beginPath();
        // this.ctx.moveTo(x - deltaX, y + 1);
        // this.ctx.lineTo(xBack - deltaXBack, yBack + 1);
        // this.ctx.lineTo(xBack + deltaXBack, yBack + 1);
        // this.ctx.lineTo(x + deltaX, y + 1);
        // this.ctx.closePath();
        // this.ctx.fill();

        this.debug = true;
    }

    drawRoundedRectangle2(x1, y1, x2, y2, width, height) {
        const dx = x2 - x1;
        const dy = y2 - y1;

        const offsetX1 = height * 0;  // t = 0
        const offsetY1 = height * 0;  // t = 0
        const zFactor1 = (1 - 0) * this.zCoordinate / (this.zCoordinate * 2);  // t = 0

        const offsetX2 = height;  // t = 1
        const offsetY2 = height;  // t = 1
        const zFactor2 = (1 - 1) * this.zCoordinate / (this.zCoordinate * 2);  // t = 1

        const rectWidth1 = height * (1 + zFactor1) * 1.5;  // increased by 50%
        const rectHeight1 = height / 2 * (1 + zFactor1) * 2;  // doubled
        const rectWidth2 = height * (1 + zFactor2) * 1.5;  // increased by 50%
        const rectHeight2 = height / 2 * (1 + zFactor2) * 2;  // doubled

        this.ctx.beginPath();
        this.ctx.moveTo(x1 + offsetX1 - rectWidth1 / 2, y1 - offsetY1 - rectHeight1 / 2);
        this.ctx.lineTo(x2 + offsetX2 - rectWidth2 / 2, y2 - offsetY2 - rectHeight2 / 2);
        this.ctx.lineTo(x2 + offsetX2 + rectWidth2 / 2, y2 - offsetY2 + rectHeight2 / 2);
        this.ctx.lineTo(x1 + offsetX1 + rectWidth1 / 2, y1 - offsetY1 + rectHeight1 / 2);
        this.ctx.closePath();
        this.ctx.fill();
    }

    drawRoundedRectangle(x1, y1, x2, y2, width, height) {
        const xfront1 = x1 - width / 4;
        const xfront2 = x1 + width / 4;
        const xback1 = x2 - width / 4;
        const xback2 = x2 + width / 4;

        const zFactorStart = this.zCoordinate / (this.zCoordinate * 2);  // t = 0
        const zFactorEnd = 0;  // t = 1

        // Draw the main rectangle
        this.ctx.beginPath();
        this.ctx.moveTo(xfront1, y1);
        this.ctx.lineTo(xback1, y2);
        this.ctx.lineTo(xback2, y2);
        this.ctx.lineTo(xfront2, y1);
        this.ctx.closePath();
        this.ctx.fillStyle = "#3C3E43";
        this.ctx.fill();

        // Draw the front ellipse
        this.ctx.beginPath();
        this.ctx.ellipse(x1, y1, width / 4 * (1 + zFactorStart), height / 2 * (1 + zFactorStart), 0, 0, 2 * Math.PI);
        this.ctx.fillStyle = "#3C3E43";
        this.ctx.fill();

        // Draw the back ellipse
        this.ctx.beginPath();
        this.ctx.ellipse(x2, y2, width / 4 * (1 + zFactorEnd), height / 2 * (1 + zFactorEnd), 0, 0, 2 * Math.PI);
        this.ctx.fillStyle = "#3C3E43";
        this.ctx.fill();
    }


    drawGrid() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        for (let i = 0; i < this.numLines; i++) {
            for (let j = 0; j < this.numLines; j++) {
                const startX = i * this.gridWidth + this.gridWidth / 2;
                const startY = j * this.gridHeight + this.gridHeight / 2;

                const dx = this.mouseX - startX;
                const dy = this.mouseY - startY;

                const distance = Math.sqrt(dx * dx + dy * dy + this.zCoordinate * this.zCoordinate);
                const lineLength = Math.min(this.baseLineLength * 1.4, distance * 2);

                const lineLengthRatio = lineLength / distance;

                const endX = startX + dx * lineLengthRatio;
                const endY = startY + dy * lineLengthRatio;

                this.ctx.fillStyle = "#3C3E43";
                this.ctx.strokeStyle = "#3C3E43";
                this.ctx.lineWidth = 2;
                this.ctx.lineCap = "round";
                // this.drawEllipseGroup(startX, startY, endX, endY, this.lineWidth, this.lineHeight);
                this.drawEllipseGroup2(startX, startY, endX, endY, this.lineWidth, this.lineHeight);
                // this.drawRoundedRectangle2(startX, startY, endX, endY, this.lineWidth, this.lineHeight); // Call new rounded rectangle drawing method
                // this.drawRoundedRectangle(startX, startY, endX, endY, this.lineWidth, this.lineHeight); // Call new rounded rectangle drawing method

            }
        }
    }

    onMouseMove(event) {
        this.targetX = event.clientX;
        this.targetY = event.clientY;
    }

    animate() {
        this.mouseX += (this.targetX - this.mouseX) * this.easing;
        this.mouseY += (this.targetY - this.mouseY) * this.easing;

        this.drawGrid();
        requestAnimationFrame(() => this.animate());
    }
}

export default VerticalGamesHero;